import template from './wizard_leave_types.html';

class WizardLeaveTypesViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}

	back_wizard()
	{
		Grape.dialog.open('WizardHolidayEntry', {});
		this.dialog.close();
	};

	next_wizard()
	{
		Grape.dialog.open('WizardFinish', {});
		this.dialog.close();
	};
};

class WizardLeaveTypesPage
{
	constructor (bindings)
	{
		this.viewModel = new WizardLeaveTypesViewModel(this);
		this.bindings = bindings;
	};
};

export default {
	name: 'WizardLeaveTypesEntry',
	dialog_class: WizardLeaveTypesPage,
	template: template,
	template_filename: 'translation/dialogs/wizard_leave_types',
	provider: 'ps'
};
